<div class="add-activity-page">
  <div class="page-inner">

    <!-- EN-TÊTE compact — breadcrumb discret -->
    <div class="page-header">
      <span class="page-header__eyebrow">Gestion des activités</span>
      <span class="eyebrow-sep">/</span>
      <span class="page-header__title">Ajouter une activité</span>
    </div>

    <!-- STEPPER -->
    <div class="stepper-wrapper">

      <div class="stepper-progress-bar">
        <div
          class="stepper-progress-fill"
          [style.width.%]="getProgressPercent()"
        ></div>
      </div>

      <nav class="stepper-nav" aria-label="Étapes de création d'activité">
        @for (step of steps; track step.id; let i = $index; let last = $last) {

          <a
            [routerLink]="[]"
            [queryParams]="{ step: step.id }"
            class="step-item"
            [class.active]="activeStepId === step.id"
            [class.completed]="completedSteps.includes(step.id)"
            [class.disabled]="!completedSteps.includes(step.id) && activeStepId !== step.id"
            [class.pmp]="step.id === 'stepfour'"
            [attr.aria-current]="activeStepId === step.id ? 'step' : null"
            [attr.aria-label]="'Étape ' + (i + 1) + ' : ' + step.label"
          >
            <div class="step-bubble">
              <span class="step-bubble__num">{{ i + 1 }}</span>
              @if (step.id === 'stepfour') {
                <div class="step-pmp-badge" title="Étape conditionnelle PMP"></div>
              }
            </div>
            <span class="step-label">{{ step.label }}</span>
          </a>

          @if (!last) {
            <div
              class="step-connector"
              [class.completed]="completedSteps.includes(step.id)"
            ></div>
          }

        }
      </nav>

    </div>

    <!-- CONTENU DE L'ÉTAPE ACTIVE -->
    <div class="step-content-area">

      @if (activeStepId === "generales") {
        <app-steponeactivities
          [generalesData]="activity.generales"
          (generalesChanges)="updateActivity($event, 'generales')"
          (typeActivityChanged)="handleTypeActivityChange($event)"
        />
      }

      @if (activeStepId === "activites") {
        <app-steptwoactivities
          [activitiesData]="activity.activites"
          (activitiesChanges)="updateActivity($event, 'activites')"
          (pmpModeSelected)="handlePmpModeChange($event)"
        />
      }

      @if (activeStepId === "budgets") {
        <app-stepthreeactivities
          [budgetsData]="activity.budgets"
          (budgetsChanges)="updateActivity($event, 'budgets')"
        />
      }

      @if (activeStepId === "stepfour" && showPmpStep) {
        <app-stepfouractivities
          [stepfourData]="activity.stepfour"
          (stepfourChanges)="updateActivity($event, 'stepfour')"
        />
      }

      @if (activeStepId === 'recap') {
        <app-recapactivities
          [activityData]="activity"
          (submitFinalActivity)="handleFinalSubmit()"
          [isLoading]="isLoading"
        />
      }

    </div>

  </div>
</div>